import { createApp } from 'vue'
import "bootstrap/dist/css/bootstrap.min.css"
import store from '@/store'
import router from '@/router'
import App from '@/App.vue'

const app = createApp(App);
// use the router
app.use(router)
// mount container
app.mount('#cq-rent-calculator');
// Install the store instance as a plugin
app.use(store)
// add bootstrap js dependency
import "bootstrap/dist/js/bootstrap.min"


